// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"231":"ac17d109","265":"bf76f644","297":"d4fc615e","643":"08ae9c33"}[chunkId] + ".js";
};